import type { IngestionUploadRes } from '@dealstack/shared/lib/generated';
import { filePagesView } from '../ingestion.utils';
import type {
	FailedUploadPart,
	FailedUploadPartView,
	LocalUpload,
	UploadCardView,
} from './useIngestionUploads.types';

/** The server takes only file names ending in `.pdf`. */
export const hasPdfName = (file: File): boolean => /\.pdf$/i.test(file.name);

/** A listed upload: counted, or never completed when it has no pages. */
export const toUploadedCard = (file: IngestionUploadRes, index: number): UploadCardView => ({
	key: file.fileId,
	name: file.name,
	state: file.pages === null ? 'incomplete' : 'uploaded',
	libraryMatch: null,
	pages: filePagesView(file.pages),
	staggerIndex: index,
});

export const toLocalCard = (upload: LocalUpload, index: number): UploadCardView => ({
	key: upload.clientRef,
	name: upload.file.name,
	state: upload.state,
	libraryMatch: upload.libraryMatch,
	pages: filePagesView(null),
	staggerIndex: index,
});

export const toFailedPartView = ({
	id,
	drafts,
	part,
	parts,
}: FailedUploadPart): FailedUploadPartView => ({ id, count: drafts.length, part, parts });

/** Some cards are still being hashed or sent, so the list is not yet what the footer counts. */
export const uploadsInFlight = (cards: readonly Pick<UploadCardView, 'state'>[]): boolean =>
	cards.some(({ state }) => state === 'preparing' || state === 'uploading');

export const uploadedCount = (cards: readonly Pick<UploadCardView, 'state'>[]): number =>
	cards.filter(({ state }) => state === 'uploaded').length;
